import { useAuth } from "./auth";

export const usePermissao = (permissao: string) => {
  const { user } = useAuth();
  return user?.perfil?.permissoes.some((p) => p.nome === permissao);
};
